import { useCallback, useContext } from "react"
import { AuthContext } from "../context/auth"
import { SubscriptionStatus } from "../protocol/customer_pb"
import { UpdateAccountInfoContext } from "../context/updateAccountInfo"

export default function useUserPlans() {
    const { userPlans, checkingUserPlans, getLatestUserPlansPerType$ } =
        useContext(AuthContext)
    const {
        queryUsedData: { credit },
    } = useContext(UpdateAccountInfoContext)
    const { hasAIPlan, hasHostingPlan } = userPlans
    const expiredAIPlan =
        userPlans.userAIPlan?.subscriptionStatus ===
        SubscriptionStatus.SUBSCRIPTION_IS_CANCELLED
    const expiredHostingPlan =
        userPlans.userHostingPlan?.subscriptionStatus ===
        SubscriptionStatus.SUBSCRIPTION_IS_CANCELLED
    const updateUserPlans = useCallback(
        (callback?: () => void) => {
            getLatestUserPlansPerType$.next({ callback })
        },
        [getLatestUserPlansPerType$],
    )
    const displayAIPlan =
        (hasAIPlan && !expiredAIPlan) ||
        (!!credit && hasHostingPlan && !expiredHostingPlan)
    const displayHostingPlan = hasHostingPlan && !expiredHostingPlan
    return {
        userPlans,
        hasAIPlan,
        hasHostingPlan,
        checkingUserPlans,
        expiredHostingPlan,
        expiredAIPlan,
        displayAIPlan,
        displayHostingPlan,
        updateUserPlans,
    }
}
